export default "__VITE_ASSET__CCy9$htP__"